// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2onZk","large":"styles_large__2lMGH"};